import ProductCount from "./product-count";
import Cart from "./cart";
import QuantityEdit from "./quantity-edit";
import LoadingIndication from "./loading-indication";
import { getComponent } from "./common";

export default class BuyProductLink{
    private link: HTMLAnchorElement;
    private productId: number;
    private quantityEdit: QuantityEdit;

    constructor(parentElement: HTMLElement) {
        this.link = parentElement.querySelector('#buy-product-button') as HTMLAnchorElement;
        const quantityEditElement = parentElement.querySelector('[data-component-id="buy-without-printing-count"]') as HTMLElement;
        if(!this.link || !quantityEditElement)
            return;

        this.quantityEdit = new QuantityEdit(quantityEditElement);
        this.productId = this.getProductId();
        this.init();
    }

    private init(): void {
        this.link.addEventListener('click', async event => {
            event.preventDefault();
            await this.addProductToCart(new ProductCount(this.productId, null, this.quantityEdit.getValue()));
        });
    }

    private async addProductToCart(productCount: ProductCount): Promise<void> {
        this.showLoadingIndication();
        const cart = new Cart();
        await cart.addProduct([productCount]);
        this.hideLoadingIndication();
        await cart.openCartDialog([productCount]);
    }

    private getProductId(): number {
        return Number.parseInt(this.link.dataset.productId);
    }

    private showLoadingIndication(): void {
        LoadingIndication.show(getComponent(document.body, 'ProductDetailOrderControls'));
    }

    private hideLoadingIndication(): void {
        LoadingIndication.hide(getComponent(document.body, 'ProductDetailOrderControls'));
    }
}
